import { bmDataCheck, bmDataCheckjs } from '../../utils/tool'

// idCard
export function idCardValidator(rule, value, callback) {
    if (!bmDataCheckjs.isEmpty(value)) {
        callback(new Error('不能为空'))
    } else if (!bmDataCheckjs.isIdCard(value)) {
        callback('请输入正确的身份证号')
    } else {
        callback()
    }
}

// phone座机
export function phoneValidator(rule, value, callback) {
    if (!bmDataCheckjs.isEmpty(value)) {
        callback(new Error('不能为空'))
    } else if (!bmDataCheckjs.isPhone(value)) {
        callback('请输入正确的座机号码, 格式如: 021-54326693')
    } else {
        callback()
    }
}

// phone手机
export function mobilePhoneValidator(rule, value, callback) {
    if (!bmDataCheckjs.isEmpty(value)) {
        callback(new Error('不能为空'))
    } else if (!bmDataCheckjs.isMobileReg(value)) {
        callback(new Error('请输入正确的手机号码'))
    } else {
        callback()
    }
}

// 数字
export function numberPhoneValidator(rule, value, callback) {
    if (!bmDataCheckjs.isEmpty(value)) {
        callback(new Error('不能为空'))
    } else if (!bmDataCheckjs.isNumber(parseFloat(value))) {
        callback(new Error('请输入数字'))
    } else {
        callback()
    }
}

// 中文
export function chineseValidator(rule, value, callback) {
    if (!bmDataCheckjs.isEmpty(value)) {
        callback(new Error('不能为空'))
    } else if (!bmDataCheckjs.checkStr(value, 'chinese')) {
        callback(new Error('请输入中文'))
    } else {
        callback()
    }
}

// 英文
export function englishValidator(rule, value, callback) {
    if (!bmDataCheckjs.isEmpty(value)) {
        callback(new Error('不能为空'))
    } else if (!bmDataCheckjs.checkStr(value, 'english')) {
        callback(new Error('请输入英文'))
    } else {
        callback()
    }
}

// url
export function urlValidator(rule, value, callback) {
    if (!bmDataCheckjs.isEmpty(value)) {
        callback(new Error('不能为空'))
    } else if (!bmDataCheckjs.isURL(value)) {
        callback(new Error('请输入正确的url'))
    } else {
        callback()
    }
}

// 大写
export function upperValidator(rule, value, callback) {
    if (!bmDataCheckjs.isEmpty(value)) {
        callback(new Error('不能为空'))
    } else if (!bmDataCheckjs.checkStr(value, 'upper')) {
        callback(new Error('请输入大写'))
    } else {
        callback()
    }
}

// 小写
export function lowerValidator(rule, value, callback) {
    if (!bmDataCheckjs.isEmpty(value)) {
        callback(new Error('不能为空'))
    } else if (!bmDataCheckjs.checkStr(value, 'lower')) {
        callback(new Error('请输入小写'))
    } else {
        callback()
    }
}

// 密码
export function pwdValidator(rule, value, callback) {
    if (!bmDataCheckjs.isEmpty(value)) {
        callback(new Error('不能为空'))
    } else if (!bmDataCheckjs.checkStr(value, 'pwd')) {
        callback(new Error('请输入正确的密码, 以字母开头，长度在6~18之间，只能包含字母、数字和下划线'))
    } else {
        callback()
    }
}

// 邮政编码
export function postalValidator(rule, value, callback) {
    if (!bmDataCheckjs.isEmpty(value)) {
        callback(new Error('不能为空'))
    } else if (!bmDataCheckjs.checkStr(value, 'postal')) {
        callback(new Error('请输入正确的邮政编码'))
    } else {
        callback()
    }
}

// 数字区间
export function minMaxValidator(rule, value, callback) {
    if (!bmDataCheckjs.isEmpty(value)) {
        callback(new Error('不能为空'))
    } else if (!bmDataCheckjs.maxMinLength(value, rule.min, rule.max)) {
        callback(new Error('数字区间输入不合法'))
    } else {
        callback()
    }
}

// 字符长度
export function lengthValidator(rule, value, callback) {
    if (!bmDataCheckjs.isEmpty(value)) {
        callback(new Error('不能为空'))
    } else if (!bmDataCheckjs.lengthCheck(value, rule.length)) {
        callback(new Error('字符长度不合法'))
    } else {
        callback()
    }
}